var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1D1D1B",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4447 23.4701C21.8137 24.08 20.9519 24.4568 20 24.4568C18.0673 24.4568 16.4988 22.905 16.4988 20.9907C16.4988 20.2076 16.762 19.4853 17.2055 18.905C17.8438 18.0657 18.857 17.5237 20 17.5237C21.9327 17.5237 23.4976 19.0755 23.4976 20.9907C23.4976 21.9621 23.0938 22.8407 22.4447 23.4701Z",
    fill: "#E1D9CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 12.571H29.9988C30.5288 12.571 31.0409 12.78 31.4159 13.1514C31.7909 13.5228 32 14.0264 32 14.5523V28.4184C32 28.9443 31.7909 29.4478 31.4159 29.8193C31.0409 30.1907 30.5288 30.3996 29.9988 30.3996H10.0012C9.47115 30.3996 8.95913 30.1907 8.58413 29.8193C8.20913 29.4478 8 28.9443 8 28.4184V14.5523C8 14.0264 8.20913 13.5228 8.58413 13.1514C8.77524 12.9639 8.9988 12.8175 9.24399 12.7184C9.48197 12.6219 9.73798 12.571 10.0012 12.571H14L16.4988 9.59961H23.5012L26 12.571ZM16.9459 25.5193C17.8474 26.1184 18.9111 26.438 20 26.438C21.4603 26.438 22.8594 25.8639 23.8906 24.8425C24.6478 24.0916 25.1635 23.1443 25.3798 22.1219C25.4591 21.7523 25.4988 21.3728 25.4988 20.9898C25.4988 19.913 25.1779 18.8594 24.5721 17.9639C23.97 17.0675 23.1082 16.3693 22.1058 15.9568C21.0998 15.5451 19.9928 15.4371 18.9255 15.6469C17.8618 15.8576 16.881 16.3764 16.1094 17.138C15.3413 17.8996 14.8185 18.8701 14.6058 19.9273C14.393 20.9844 14.5012 22.0791 14.9195 23.0746C15.3341 24.0701 16.0409 24.921 16.9459 25.5193Z",
    fill: "#E1D9CD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamIcon);
export default __webpack_public_path__ + "static/media/camIcon.f2aa0f91ba07a264bbf8707da5c255f4.svg";
export { ForwardRef as ReactComponent };